import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Image, Ratio } from 'react-bootstrap';
import { ContentContainer } from '../../../components';
import { fetchNews } from 'cdfdigital-common/build/actions';
import appendQueryString from 'cdfdigital-common/build/helper/append-query-string';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { NewsItem, NewsState } from 'cdfdigital-common/src/models';

const parseYouTubeId = (url: string) => {
  const regex =
    /^.*(youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|&vi?=)([^#&?]*).*/;
  const matches = url.match(regex);
  return matches ? matches[2] : null;
};

const parseVideoUrl = (url: string) => {
  if (url.includes('youtu')) {
    const id = parseYouTubeId(url);
    if (id) {
      return (
        'https://www.youtube.com/embed/' +
        id +
        '?rel=0&controls=1&modestbranding=1'
      );
    }
  }
  return url;
};

const NewsItemComponent: React.FC = () => {
  const history = useHistory();

  const match = useRouteMatch<any>();

  const [newsItem, setNewsItem] = React.useState<undefined | NewsItem>(
    undefined,
  );

  const { data: news } = useSelector<any, NewsState>(
    (state) => state.newsReducer,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (!news.length) {
      dispatch(fetchNews());
    }
  }, [dispatch, news]);

  useEffect(() => {
    if (news.length) {
      setNewsItem(news.find((item) => item._id === match.params.id));
    }
  }, [news, match.params.id]);

  if (!newsItem) {
    return (
      <ContentContainer id="container-newsItem">
        <Row>
          <Col xs={12}>Carregando...</Col>
        </Row>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer
      id="container-newsItem"
      header={
        newsItem.video ? null : (
          <div className="header">
            <Image
              className="image"
              fluid
              src={appendQueryString(
                newsItem.image,
                'w=1500&h=500&fit=crop&blend=000000&bm=darken&balph=30',
              )}
            />
            <div className="news-info">
              <h2>{newsItem.title}</h2>
              <h4 className="description">{newsItem.description}</h4>
            </div>
          </div>
        )
      }
    >
      <Row className="no-gutters news">
        <Col xs={12}>
          {newsItem.video ? (
            <div className="video mb-4">
              <Ratio aspectRatio="16x9">
                <embed src={parseVideoUrl(newsItem.video)} />
              </Ratio>
            </div>
          ) : null}
        </Col>
      </Row>
      {newsItem.video && (
        <div>
          <h3>{newsItem.title}</h3>
          <p className="description">{newsItem.description}</p>
        </div>
      )}
      <Row>
        <Col xs={12}>
          <p className="text">{newsItem.text}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="back-btn btn-center">
          <button onClick={() => history.goBack()} className="btn btn-primary">
            Voltar
          </button>
        </Col>
      </Row>
    </ContentContainer>
  );
};

export default NewsItemComponent;
